import React from 'react';
import { BsDiscord } from 'react-icons/bs';
import { useSearchParams } from 'react-router-dom';
import './Login.css';

const Login: React.FC = () => {
    const [searchParams] = useSearchParams();
    const error = searchParams.get('error');
    const authUrl = process.env.NODE_ENV === 'development'
        ? `${window.location.protocol}//${window.location.hostname}:5000/auth/discord`
        : `${window.location.origin}/auth/discord`;

    return (
        <main className="login-page">
            <section className="login-card" aria-labelledby="login-title">
                <h1 id="login-title">Tableau de bord de modération<br />PATATE</h1>
                <p>Connectez-vous avec Discord pour<br />accéder au tableau de bord.</p>
                {error && (
                    <p className="login-error" role="alert">
                        {error === 'unauthorized'
                            ? "Vous devez disposer des permissions de modération sur au moins un serveur."
                            : "La session n'a pas pu être créée. Veuillez réessayer."}
                    </p>
                )}
                <a className="discord-login-button" href={authUrl}>
                    <BsDiscord aria-hidden="true" />
                    <span>Se connecter avec Discord</span>
                </a>
            </section>
        </main>
    );
};

export default Login;
